module.exports = __webpack_public_path__ + "img/tea-cup.e6f0c216.png";